import { ISSUER_SESSION_KEY, JVCEF, VRPAT } from '~/config/constants';

export function getIssuer(): string {
  const { hostname } = window.location;
  let issuer = VRPAT;

  const sessionIssuer = sessionStorage.getItem(ISSUER_SESSION_KEY);
  if (
    hostname.includes('caixaprepagos') ||
    (sessionIssuer && sessionIssuer === JVCEF)
  ) {
    issuer = JVCEF;
  }

  return issuer;
}
